// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiParameter,
    del,
    get,
    HasPagingParameters,
    patch,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

const trainingCoursesUrl = "api/sainc/courses/myTrainingCourses";

export interface CoursesModel extends BaseModel {
    registrationDate: string;
    courseName: string;
    syncedWithThinkific: boolean;
    expirationDate?: string;
    completionDate?: string;
    status?: string;
}

export interface CoursesCollectionModel extends BaseModel {
    myTrainingCourses: CoursesModel[] | null;
    pagination: PaginationModel | null;
}

export interface GetCoursesApiParameter extends ApiParameter, HasPagingParameters {
    sortBy?: string;
}

export async function getMyTrainingCourses(
    parameter: GetCoursesApiParameter,
): Promise<ServiceResult<CoursesCollectionModel>> {
    try {
        const result = await get<CoursesCollectionModel>(trainingCoursesUrl, parameter);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
